import React from "react";
import { useLanguage } from '../context/LanguageContext';

/**
 * Sub-component: Encapsulates text info and ensures vertical alignment
 */
const CardTextMeta = ({ card, position, showingCard }) => {
    // FIX: Must call useLanguage here to use t()
    const { t } = useLanguage();

    return (
        <div className="card-text-meta">
            {/* 1. Card Metadata */}
            {showingCard && card && (
                <div className="card-meta">
                    <div className="card-name">{card.name}</div>
                    <div className={`orientation ${card.orientation === t('reversed') ? "reversed" : "upright"}`}>
                        {card.orientation}
                    </div>
                    <div className="card-meaning">{card.meaning}</div>
                </div>
            )}

            {/* 2. Position Label */}
            <div className="pos-label">{position}</div>
        </div>
    );
};

export default function TarotCard({ card, position, index = 0, isPlaceholder }) {
    const { t } = useLanguage();
    
    // Determine if we should show the card face or the back
    const placeholder = typeof isPlaceholder === "boolean" ? isPlaceholder : !card;
    const showingCard = !placeholder && !!card;

    const delay = `${index * 120}ms`;

    return (
        <div className="tarot-card">
            
            {/* Flip container: Only handles the visual card flip */}
            <div className={`flip-container ${showingCard ? "flipped" : ""}`} style={{ transitionDelay: delay }}>
                <div className="flip-inner">
                    <div className="flip-back">
                        <div className="back-box" />
                    </div>
                    <div className={`flip-front ${showingCard ? "active" : ""}`}>
                        {showingCard && card?.image && (
                            <img
                                src={card.image}
                                alt={card.name}
                                className="card-image"
                                style={{
                                    transform: card.orientation === t('reversed') ? "rotate(180deg)" : "none",
                                }}
                            />
                        )}
                    </div>
                </div>
            </div>

            {/* Text Metadata: Rendered below the card. 
               If you need different layouts for index > 3, 
               apply a conditional class to the wrapper.
            */}
            <CardTextMeta 
                card={card} 
                position={position} 
                showingCard={showingCard} 
            />
        </div>
    );
}